/**
 * API Configuration
 * Centralized API configuration for the entire application
 */

// Production API URL - Use relative path for same-origin requests
const PRODUCTION_API_URL = '/api/blog';

// Site URLs
const PRODUCTION_SITE_URL = 'https://kirikkalefar.com';
const DEVELOPMENT_SITE_URL = 'http://localhost:3000';

// Environment detection
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Cache buster - forces browser to fetch fresh data
const CACHE_BUSTER = Date.now();

// Export configuration
// Use relative URL for production - works better with same-origin
export const API_URL = PRODUCTION_API_URL;
export const SITE_URL = isLocalhost ? DEVELOPMENT_SITE_URL : PRODUCTION_SITE_URL;

// Mock data is DISABLED - using real API only
export const USE_MOCK_DATA = false;

// API endpoints
export const ENDPOINTS = {
    // Public endpoints
    settings: '/settings',
    posts: '',
    post: (slug) => `/${slug}`,
    gallery: '/gallery',
    login: '/login',

    // Protected endpoints (require auth)
    admin: {
        posts: '/admin',
        post: (id) => `/admin/${id}`,
        settings: '/settings',
        gallery: '/gallery',
        galleryImage: (filename) => `/gallery/${filename}`,
    }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => `${API_URL}${endpoint}`;

// Helper function to get gallery image URL
export const getGalleryImageUrl = (filename) => {
    if (!filename) return '';
    if (filename.startsWith('http://') || filename.startsWith('https://')) {
        return filename;
    }
    if (filename.startsWith('/gallery/')) {
        return filename;
    }
    return `/gallery/${filename}`;
};

// Helper function to get auth header
export const getAuthHeader = () => {
    const token = localStorage.getItem('adminToken');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};

// Console log current environment
console.log('🔌 API Mode: PRODUCTION (Real Database)');
console.log('📍 API URL:', API_URL);
console.log('🌐 Site URL:', SITE_URL);

export default {
    API_URL,
    SITE_URL,
    USE_MOCK_DATA,
    ENDPOINTS,
    getApiUrl,
    getAuthHeader,
    isLocalhost
};
